<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" :appendToBody="true" width="950px">
        <!-- 区分不同设置 展示不同布局 -->
        <div class="content">
            <div class="div-class" v-for="(op, opIndex) in dataAnalysis" :key="opIndex">
                <header class="header-class" v-if="op.check != undefined">
                    <el-checkbox v-model="op.check">
                        <i :class="op.icon" :title="op.title"></i>
                        {{ op.headerText }}
                    </el-checkbox>

                    <!-- <h3>{{ op.headerText }}</h3> -->
                </header>
                <section class="section-calss">
                    <el-select v-model="op.type" class="select-class uk-margin-right" @change="changeAlFn($event, opIndex)">
                        <el-option v-for="item in op.sWay" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>

                    <el-select v-if="op.type !== 3" v-model="op.dateType" class="select-class uk-margin-right" @change="changeDateFn($event, opIndex)">
                        <el-option v-for="(item, index) in op.type !== 1 ? dfDateType : yoyType" :key="index" :label="item.label" :value="item.value" />
                    </el-select>

                    <!-- dateType 年/月/日 -->
                    <yearPicker
                        arPicker
                        v-if="op.type === 0 && op.dateType === 0"
                        style="width:300px"
                        labelText=""
                        :initYear="op.timeValue"
                        @changetime="
                            row => {
                                return changeTime(row, opIndex);
                            }
                        "
                        :key="opIndex"
                        :disableCondition="disableCondition"
                    />
                    <el-date-picker
                        :clearable="false"
                        v-else-if="op.type !== 3"
                        :value-format="formatConvert[op.timeType]"
                        :key="op.timeType"
                        v-model="op.timeValue"
                        :type="op.timeType"
                        :range-separator="$t('public.to')"
                        :start-placeholder="$t('public.start_date')"
                        :end-placeholder="$t('public.end_date')"
                        :picker-options="pickerOptions(op)"
                    >
                    </el-date-picker>

                    <!-- 日期时间选择器 -->
                    <el-date-picker
                        :clearable="false"
                        v-else
                        v-model="op.timeValue"
                        type="datetimerange"
                        :range-separator="$t('public.to')"
                        :key="op.timeType + opIndex"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :start-placeholder="$t('public.start_date')"
                        :end-placeholder="$t('public.end_date')"
                    >
                    </el-date-picker>

                    <div class="right-content" v-show="op.type !== 0 && op.type !== 3">
                        <div>目标对象:{{ computedTarget(op.timeValue) }}</div>
                        <br />
                        <div>对比对象:{{ computedContrast(op.timeValue) }}</div>
                    </div>
                </section>
            </div>
        </div>
        <div slot="footer">
            <!-- 这里的按钮只有绑定了特定的事件后才会出现 -->
            <el-button type="primary" @click="handleSave" v-if="$listeners.save">{{ $t('public.save') }}</el-button>
            <el-button type="primary" @click="handleSaveImpl" v-if="$listeners.saveImpl">{{ $t('public.saveImpl') }}</el-button>
            <el-button type="primary" @click="handleImpl" v-if="$listeners.impl">{{ $t('public.impl') }}</el-button>
            <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import moment from 'moment';
import yearPicker from './Year.vue';
import { defaultType, yoyType } from './config/dateType';
let _minTime = null;
let _maxTime = null;
export default {
    props: ['title', 'isShow', 'config', 'defaultSetting'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val);
            }
        },
        dfDateType() {
            return defaultType;
        },
        yoyType() {
            return yoyType;
        }
    },
    watch: {
        config(newVal) {
            this.dataAnalysis = this.config;
        }
    },
    components: {
        yearPicker
    },
    data() {
        return {
            dateValue2: [],
            // year--单选年&&年
            // monthrange--年月
            // daterange--年月日
            // date--单选年月日
            // month--单选年月
            // date--单选年月日
            timeTypeArray: ['year', 'monthrange', 'daterange', 'date', 'month', 'date'],
            // 数据分析配置
            dataAnalysis: this.config,
            formatConvert: {
                year: 'yyyy',
                monthrange: 'yyyy-MM',
                daterange: 'yyyy-MM-dd',
                date: 'yyyy-MM-dd',
                month: 'yyyy-MM'
            }
        };
    },
    methods: {
        pickerOptions({ type, dateType }) {
            // if (!type || !dateType) return {}
            if (type === 1) {
                // 统计月 限制 12个月
                if (dateType === 1) {
                    timeRange = 12 * 30 * 24 * 60 * 60 * 1000;
                }
            } else if (type === 2) {
            }

            let timeRange;
            return {
                onPick: ({ maxDate, minDate }) => {
                    if (!maxDate) {
                        timeRange = this.getTimeFn(minDate); // 31天 判断这个的值
                        _minTime = minDate.getTime() - timeRange; // 最小时间
                        _maxTime = minDate.getTime() + timeRange; // 最大时间
                        // 如果选了两个时间，那就清空本次范围判断数据，以备重选
                    } else {
                        _minTime = _maxTime = null;
                    }
                },
                disabledDate: time => {
                    // if (_minTime && _maxTime) {
                    //     console.log(time.getTime());
                    //     console.log(_minTime);
                    //     console.log(_maxTime);
                    //     return time.getTime() < _minTime * 1000 || time.getTime() > _maxTime * 1000
                    // }

                    let start;
                    // 日期
                    if (dateType === 2 || type === 3) {
                        start =
                            time.getTime() <
                            moment(new Date())
                                .subtract(31, 'days')
                                .valueOf();
                    } else if (dateType === 1) {
                        // 月份
                        start =
                            time.getTime() <
                            moment(new Date())
                                .subtract(13, 'months')
                                .endOf('month')
                                .valueOf();
                    } else {
                        start = false;
                    }
                    return time.getTime() > Date.now() || start;
                }
            };
        },
        // 获取准确时间
        getTimeFn(time) {
            // 获取选中的第一个时间的往后以及往前12个月 如 2022 06 01 --2021 06 01   format('YYYY-MM-DD')
            const realTime = moment(time)
                .subtract(12, 'months')
                .valueOf();

            return realTime;
        },
        // 时间格式化
        timestampToTime(timestamp) {
            if (!timestamp) return;
            var date = new Date(timestamp);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        changeTime(row, index) {
            const data = this.dataAnalysis[index];
            data.timeValue = [this.$timetransition(row.startYear, 'Y').split('-')[0], String(this.$timetransition(row.endYear, 'Y').split('-')[0] * 1 - 1)];
            // console.log('row==>', row,index);
        },
        // 时间框类型的显示 type -- 分析的方法  dateType 分析的范围 年月日
        timeShow(type, dateType) {
            let newType;
            // 统计 同比  比例
            if (type === 0 || type === 1) {
                switch (dateType) {
                    case 1: {
                        newType = 'monthrange';
                        break;
                    }
                    case 2: {
                        newType = 'daterange';
                        break;
                    }
                    default:
                        break;
                }
            }
            // 环比
            else {
                switch (dateType) {
                    case 0: {
                        newType = 'year';
                        break;
                    }
                    case 1: {
                        newType = 'month';
                        break;
                    }
                    case 2: {
                        newType = 'date';
                        break;
                    }
                    default:
                        break;
                }
            }
            return newType;
        },
        // 分析方法
        changeAlFn(type, index) {
            const vData = this.dataAnalysis[index];
            // 操作时间框的类型 统计+同比
            const newType = this.timeShow(type, vData.dateType);
            vData.timeType = newType;
            // 清空分析范围以及时间
            vData.dateType = 1;
            vData.timeValue = '';
            this.changeDateFn(vData.dateType, index);
        },
        changeDateFn(dateType, index) {
            const method = this.config[index].type;

            const date = new Date();

            switch (dateType) {
                // 年 默认是近三年
                case 0:
                    // 统计 同比
                    if (method === 0 || method === 1) {
                        this.config[index].timeValue = [
                            moment(date)
                                .subtract(3, 'years')
                                .startOf('month')
                                .format('YYYY'),
                            moment(date)
                                .subtract(0, 'years')
                                .startOf('month')
                                .format('YYYY')
                        ];
                    } else {
                        // 环比 默认本年
                        this.config[index].timeValue = moment(date).format('YYYY');
                    }

                    break;
                // 月 默认是近12个月
                case 1:
                    // 统计 同比
                    if (method === 0 || method === 1) {
                        this.config[index].timeValue = [
                            moment(date)
                                .subtract(12, 'months')
                                .startOf('month')
                                .format('YYYY-MM'),
                            moment(date)
                                .subtract(0, 'months')
                                .startOf('month')
                                .format('YYYY-MM')
                        ];
                    } else {
                        this.config[index].timeValue = moment(date).format('YYYY-MM');
                    }
                    break;
                case 2:
                    // 天 默认近31天
                    if (method === 0 || method === 1) {
                        this.config[index].timeValue = [
                            moment(date)
                                .subtract(31, 'days')
                                .startOf('month')
                                .format('YYYY-MM-DD'),
                            moment(date)
                                .subtract(1, 'days')
                                .startOf('month')
                                .format('YYYY-MM-DD')
                        ];
                    } else {
                        this.config[index].timeValue = moment(date).format('YYYY-MM-DD');
                    }

                    break;
            }
            const vData = this.dataAnalysis[index];
            // vData.timeValue = '';

            const newType = this.timeShow(vData.type, dateType);
            vData.timeType = newType;
        },
        getConfig() {
            const result = {};
            const flag = Object.keys(this.dataAnalysis).some(key => {
                return this.dataAnalysis[key].check || this.dataAnalysis[key].check == undefined;
            });
            if (!flag) {
                this.$message.warning($t('integration.check_at_least_one_item_of_data'));
                return '';
            }
            Object.keys(this.dataAnalysis).forEach(key => {
                const item = this.dataAnalysis[key];
                // 选中 或者 没有定义
                if (item.check || item.check === undefined) {
                    result[key] = {
                        method: item.type,
                        way: item.dateType,
                        startTime: item.timeValue instanceof Array ? item.timeValue[0] : undefined,
                        endTime: item.timeValue instanceof Array ? item.timeValue[1] : undefined,
                        time: item.type === 2 && typeof item.timeValue === 'string' ? item.timeValue : undefined
                    };
                }
            });
            return result;
        },
        handleSave() {
            const result = this.getConfig();
            if (!result) return;

            this.$emit('save', result);
            this.$emit('update:isShow', false);
        },
        handleSaveImpl() {
            const result = this.getConfig();
            if (!result) return;
            this.$emit('saveImpl', result);
            this.$emit('update:isShow', false);
        },
        handleImpl() {
            const result = this.getConfig();
            if (!result) return;
            this.$emit('impl', result);
            this.$emit('update:isShow', false);
        },
        // 计算目标对象
        computedTarget(value) {
            if (value instanceof Array) {
                return `${value[0]}~${value[1]}`;
            } else {
                return value;
            }
        },
        // 计算对比对象 年份-1
        computedContrast(value) {
            if (!value || value === ',') {
                return '';
            }
            if (value instanceof Array) {
                const result = [];
                if (!value[0]) {
                    return '';
                }
                const date1 = value[0].split('-');
                date1[0] = String(date1[0] * 1 - 1);
                result.push(date1.join('-'));

                const date2 = value[1].split('-');
                date2[0] = String(date2[0] * 1 - 1);
                result.push(date2.join('-'));
                return result.join('~');
            } else {
                const result = [];
                const date = value.split('-');
                date[0] = String(date[0] * 1 - 1);
                return date.join('-');
            }
        },

        // 传入配置
        setConfig(config = {}) {
            // 检查是否使用默认配置（config 为空或所有项都有 default: true）
            const useDefault = !config || Object.keys(config).length === 0 ||
                Object.keys(config).every(key => config[key] && config[key].default);

            config = { ...this.defaultSetting, ...config };

            // config默认是一个Object 按照后端返回的进行配置项的设置
            Object.keys(config).forEach(key => {
                if (!this.config[key]) {
                    return;
                }

                // 设置 check 状态
                if (this.config[key].check != undefined) {
                    if (useDefault) {
                        // 使用默认配置时，所有项 check=true
                        this.config[key].check = true;
                    } else if (!config[key].default) {
                        // 使用后端配置时，只有后端返回的项 check=true
                        this.config[key].check = true;
                    } else {
                        // 后端没有返回的项（defaultSetting 补充的），check=false
                        this.config[key].check = false;
                    }
                }

                // 配置覆盖 第二层配置也得覆盖 并去掉default
                config[key] = { ...this.defaultSetting[key], ...config[key], default: undefined };
                // 设置分析方法
                this.config[key].type = config[key].method;
                // 设置年/月/日
                this.config[key].dateType = config[key].way;

                this.changeDateFn(config[key].way, key);

                // 设置时间 / 时间范围
                if (config[key].time) {
                    // 说明是环比
                    this.config[key].timeValue = config[key].time + '';
                } else {
                    // 否则就是一个日期范围
                    this.config[key].timeValue = [config[key].startTime, config[key].endTime];
                    const timeType = {
                        1: 'monthrange',
                        2: 'daterange'
                    };
                    this.$set(this.config[key], 'timeType', timeType[config[key].way]);
                }
            });
        },
        disableCondition(item) {
            const date = new Date();
            const curYear = parseInt(date.getFullYear());
            const startYear = curYear - 10;
            return item > curYear || item < startYear;
        }
    }
};
</script>

<style lang="scss" scoped>
$bordercolor: #cccccc;

.content {
    width: 100%;

    .div-class {
        border: 1px solid $bordercolor;
        margin-bottom: 15px;

        .header-class {
            height: 30px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            border-bottom: 1px solid $bordercolor;

            i,
            h3 {
                margin-left: 10px;
            }
        }

        .section-calss {
            padding: 10px;
            height: 50px;
            display: flex;
            align-items: center;

            .select-class {
                width: 100px;
            }

            .right-content {
                margin-left: 30px;
            }
        }
    }

    ::v-deep .el-date-editor--year .el-input__inner {
        padding-left: 30px !important;
    }

    ::v-deep .el-date-editor--month .el-input__inner {
        padding-left: 30px !important;
    }

    ::v-deep .el-date-editor--date .el-input__inner {
        padding-left: 30px !important;
    }
}
</style>
